import { Breakpoints } from '@/common/theme/constants';
import { SxProps } from '@mui/material/styles';

export const styledFormWrapper: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  my: '20px',
};

export const styledVerificationSection: SxProps = {
  maxWidth: '550px',
  display: 'grid',
  gridTemplateColumns: '1fr 0.05fr',
  gap: 1,
};

export const styledButtonGroup: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  flex: 1,

  [`@media (min-width:${Breakpoints.md}px)`]: {
    flexDirection: 'row',
  },
};

export const styledOutlinedButton: SxProps = {
  width: '100%',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    width: '80%',
  },
};

export const styledInfoButton: SxProps = {
  gridColumn: '2',
  pt:'4px',
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
};

export const styledSectionTitle: SxProps = {
  gridColumn: 'span 2',
};

export const styledDatePicker: SxProps = {
  gridColumn: 'span 2',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    gridColumn: 'span 1',
  },
};

export const styledMembershipNumberField: SxProps = {
  gridRow: '2',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    gridRow: '3',
  },
};

export const styledMembershipNumberButton: SxProps = {
  ...styledInfoButton,
  gridRow: '2',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    gridRow: '3',
  },
};

export const styledButtonSection: SxProps = {
  ...styledVerificationSection,
  gridTemplateColumns: '1fr',
  [`@media (min-width:${Breakpoints.md}px)`]: {
    gridTemplateColumns: '1fr 0.05fr',
  },
};
